/**
 * tripPlanningApi — web wrapper around `@wg/api/trip-planning`. Same surface
 * as `apps/WunderGuide/api/tripPlanningApi.ts`.
 */
import { createTripPlanningApi } from '@wg/api/trip-planning';
import { httpClient } from '../http';
import logger from '../utils/logger';

const api = createTripPlanningApi(httpClient, logger);

export const generateTrip = api.generateTrip;
export const getGenerationStatus = api.getGenerationStatus;
export const getGenerationJobs = api.getGenerationJobs;
export const regenerateTrip = api.regenerateTrip;
export const approveItem = api.approveItem;
export const rejectItem = api.rejectItem;
export const replaceItem = api.replaceItem;
export const approveAll = api.approveAll;
export const getTripSummary = api.getTripSummary;

export const tripPlanningApi = api;
export default api;
